export default {
    404: {
        "oops": "不好意思!",
        "error_message": "您要查找的頁面當前不可用。錯誤代碼：404",
        "go_back": "回到主頁面",
    }
};
